import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import BaseViewStore from 'base-viewstore';

export class LayoutViewStore extends BaseViewStore {
}


export class SingleLayoutViewStore extends BaseViewStore {
}

export class ColumnLayoutViewStore extends BaseViewStore {
}

export class ColumnsWithTitleLayoutViewStore extends BaseViewStore {
}

export class RowsLayoutViewStore extends BaseViewStore {
}

export class TableLayoutViewStore extends BaseViewStore {
}



// WEBPACK FOOTER //
// ./app_modules/form-control-activity/layouts/viewstore.js